import React from 'react';
import './About.css';

const CheckIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1b9fcf" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

const HIGHLIGHTS = [
  'Professional and experienced team',
  'Quick turnaround time',
  'Transparent pricing',
  'End-to-end support',
];

const About = () => (
  <section id="about" className="section about">
    <div className="container about__inner">
      {/* Left: Text content */}
      <div className="about__text">
        <h2 className="about__title">About Thar Enterprises</h2>
        <p className="about__para">
          We are a dedicated business services firm helping entrepreneurs and companies navigate
          the complexities of registration, compliance, and financial documentation. Our team
          brings deep expertise and a commitment to making these processes smooth and stress-free
          for every client.
        </p>
        <p className="about__para">
          From GST registration to income tax filing, we provide reliable, accurate, and
          timely services. Our goal is to be the one-stop solution for all your business
          compliance needs so you can focus on growth and innovation.
        </p>

        <ul className="about__highlights">
          {HIGHLIGHTS.map((item) => (
            <li key={item} className="about__highlight-item">
              <CheckIcon />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Right: Experience stat card */}
      <div className="about__stat-wrap">
        <div className="about__stat-card">
          <span className="about__stat-number">10+</span>
          <span className="about__stat-label">Years of Experience</span>
          <span className="about__stat-sub">Serving businesses with excellence</span>
        </div>
      </div>
    </div>
  </section>
);

export default About;
